import { ApiError, Levels } from "./error";

const baseURL = `/api/sso/userinfo`;
const loggedOutURL = "/loggedout.html";

export default {
  getUserinfo() {
    return (
      fetch(this.getBackendUrl() + `${baseURL}`, {
        mode: "cors",
        credentials: "include"
      })
        //Überprüfung der Verbindung
        .catch(() => {
          throw new ApiError({
            level: Levels.ERROR,
            message: "Berechtigungen konnten nicht geladen werden. Keine Verbindung zum Server, bitte Internetverbindung überprüfen."
          });
        })
        .then(response => {
          if (!response.ok) {
            throw new ApiError({
              level: Levels.ERROR,
              message: "Die Berechtigungen konnten nicht geladen werden."
            });
          }
          return response.json();
        })
    );
      },

  logout() {
    fetch(this.getBackendUrl() + `/logout`, {
      method: "post",
      mode: "cors",
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: "include"
    })
      .catch(() => {
        // mit fetch ist es aktuell nicht möglich, den Location Header des Redirects zu prüfen,
        // der nach einem erfolgreichen Logout vom API-Gateway zurückgesendet wird
        // siehe https://github.com/whatwg/fetch/issues/763#issuecomment-466631598
        // deswegen: info loggen - wird schon gepasst haben -> auf Loggedout Seite weiterleiten
        window.location.href = loggedOutURL;
      })
      .then(() => {
        window.location.href = loggedOutURL;
      });
  },

  getBackendUrl() {
      if (window.location.hostname === 'localhost' && window.location.port === '8081') {
          return 'http://localhost:8082';
      } else {
          return '';
      }
  }
};